export default __webpack_public_path__ + "static/media/portrait.81248b3f.png";